<template>
    <div class="px-8 py-6">
        <div v-if="data.isLoading" class="flex h-full w-full items-center justify-center">
            <CatLoading/>
        </div>
        <div v-else-if="!data.images.length" class="flex h-full w-full cursor-default flex-col items-center justify-center">
            <CatHole2 class="h-[160px] w-[160px]"/>
            <span>{{$t('noData')}}</span>
        </div>
        <div v-else class="w-full cursor-pointer">
            <div
                v-for="(img, idx) in data.images"
                :key="img.image_id"
                class="mb-2 flex min-h-[400px] w-full items-center justify-center rounded border border-grey-40 hover:border-eureka-500"
                @click="imagePanelService.open(idx)"
            >
                <img :src="img.storage_path" alt="" class="w-2/5">
            </div>
        </div>
        <ImagePanel v-show="imagePanelService.isShow" :service="imagePanelService"/>
    </div>
</template>

<script setup lang="ts">
import { useDetailImage } from './use-detail-image';
import { CatLoading, CatHole2 } from '@eureka/cat';
import { ImagePanel } from '@eureka/shared/solution-card';

const { data, imagePanelService } = useDetailImage();

</script>
